<template>
  <div id='footer' class="footer-container">
    <div class="modal-mask" style="position: absolute;">
    <div class="flex fxdc jcsb footer-wrap white-color">
      <div class="flex jcc">
        <div style="width:550px">
          <div class="fs14 fw500" style="margin: 10px 0">友情链接</div>
          <div class="flex fww">
            <a v-for="(item, index) in commonData.friendlylink" :key="index" :href="item.url" target="_blank">
              <img class="friendlylink-image" :src="item.image" alt="" />
            </a>
          </div>
          <div class="fs14 fw500" style="margin: 10px 0">我们的产品</div>
          <div class="flex tac fs12">
            <div class="code-wrap">
              <img class="code-image" src="https://qishimai-1257428522.file.myqcloud.com/website/new/QR_code/miniprogram_code.png" alt="" />
              <div>七十迈旅行<br />小程序</div>
            </div>
            <div class="code-wrap">
              <img class="code-image" src="https://qishimai-1257428522.file.myqcloud.com/website/new/QR_code/officialaccount_code.png" alt="" />
              <div>七十迈旅行<br />公众号</div>
            </div>
            <div>
              <img class="code-image" style="border-radius:8px" src="https://qishimai-1257428522.file.myqcloud.com/website/other/qishimaiguojizijia.png" alt="" />
              <div>七十迈国际自驾<br />公众号</div>
            </div>
          </div>
        </div>
        <div>
          <div class="fs14 fw500" style="margin: 10px 0">定制行程</div>
          <div class="flex aic">
            <div class="customize-input-wrap">
              <input placeholder='请填写目的地' type="text" v-model="place">
            </div>
          </div>
          <div class="flex aic">
            <div class="customize-input-wrap">
              <input placeholder='请填写手机号' type="number" v-model="phoneNumber">
            </div>
          </div>
          <div class="flex aic">
            <div class="flex jcsb aic customize-input-wrap">
              <input style="width:120px" placeholder='请填写验证码' type="number" v-model="authCode">
              <div class="main-color fs12 cp" @click="sendLoginAuthCode">{{authCodeCountDown > 0 ? `${authCodeCountDown}s` : '获取验证码'}}</div>
            </div>
          </div>
          <div class="button customize-btn cp" style="margin-top:16px" @click="customizeSubmit">免费定制行程</div>
        </div>
      </div>
      <div class="flex aic jcsa copyright-wrap fs10">
        <div>Copyright © 2014 北京七十迈国际旅行社有限公司. 保留所有权利</div>
        <div>备案号：<a class="white-color" href="https://beian.miit.gov.cn/" target="_blank">京ICP备15033671号-3</a></div>
        <div>地址：北京市朝阳区南磨房路37号华腾北搪商务大厦516室</div>
        <div>电话：4008-270-170</div>
      </div>
    </div></div>
    <div v-if="showSuccessModal" class='modal-mask'>
      <div class='modal-box'>
        <img src="https://qishimai-1257428522.file.myqcloud.com/website/new/customerservice_avatar.png" class="modal-avatar" />
        <div class='modal-title' style='margin-top:50px;'>提交成功</div>
        <div class='modal-content' style='margin-top:6px;'>我们已收到您的需求</div>
        <div class='modal-content'>旅行顾问将在<span style="color: #0BA09A;">24小时之内联系您</span></div>
        <div class='modal-content' style='margin-bottom:16px;'>请保持电话畅通</div>
        <div class='modal-btn' @click="showSuccessModal = false">好的</div>
      </div>
    </div>
    <div v-if="showToast" class="toast">
      <div>{{toastContent}}</div>
    </div>
  </div>
</template>

<script>
import commonData from '@/utils/staticData/commonData';
export default {
  name: 'Footer',
  data () {
    return {
      commonData,
      phoneNumber: '',
      authCode: '',
      place: '',
      authCodeCountDown: 0,
      showSuccessModal: false,
      showToast: false,
      toastContent: '',
    }
  },
  methods: {
    sendLoginAuthCode() {
      if (this.authCodeCountDown > 0) {
        return;
      }
      if (this.phoneNumber) {
        const res = /^1\d{10}$/.test(this.phoneNumber);
        if (!res) {
          this.toast('请正确输入手机号！');
          return;
        }
        return get(api.getAuthCode, { phoneNumber: this.phoneNumber }).then((res) => {
          this.toast('发送成功！');
          this.authCodeCountDown = 60;
          this.authCodeCountDownHandle();
        }).catch((err) => {
          this.toast('发送验证码失败，请稍后重试');
        })
      } else {
        this.toast('请填写手机号！');
      }
    },
    authCodeCountDownHandle() {
      setTimeout(() => {
        this.authCodeCountDown = this.authCodeCountDown - 1;
        this.authCodeCountDownHandle()
      }, 1000)
    },
    customizeSubmit() {
      if ( this.phoneNumber === '' || this.place === '' || this.authCode === '' ) {
        this.toast('请完整填写信息！');
        return;
      }
      return post(api.insertClue, {
        phoneNumber: this.phoneNumber,
        authCode: this.authCode,
        place: this.place,
        source: '官网',
      }).then((res) => {
        this.phoneNumber = '',
        this.authCode = '',
        this.place = '',
        this.authCodeCountDown = 0,
        // this.toast('提交失败！');
        this.showSuccessModal = true;
      }).catch((err) => {
        this.toast('提交失败！');
      })
    },
    copyToClipboard(s) {
      if (window.clipboardData) {
          window.clipboardData.setData('text', s);
          this.toast('复制成功！');
      } else {
        (function(s) {
          document.oncopy = function(e) {
            e.clipboardData.setData('text', s);
            e.preventDefault();
            document.oncopy = null;
          }
        })(s);
        document.execCommand('Copy');
        this.toast('复制成功！');
      }
    },
    toast(content) {
      this.toastContent = content;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-container {
  position: relative;
  background-image: url('https://qishimai-1257428522.file.myqcloud.com/website/static/home_bg2.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 25.8vw;
  max-height: 400px;
  min-height: 360px;
}
.footer-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 10px;
}
.friendlylink-image {
  width: 80px;
  margin: 0 14px 10px 0;
}
.code-wrap {
  margin-right: 20px;
}
.code-image {
  width: 80px;
}
.copyright-wrap {
  height: 38px;
  padding: 0 150px;
  background: rgba(0, 0, 0, 0.3);
}
.customize-input-wrap {
  height: 36px;
  width: 190px;
  margin: 6px 0 6px 0;
  padding: 0 10px;
  background-color: #fff;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
input {
  height: 36px;
  width: 190px;
}
.customize-btn {
  margin-top: 10px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue